import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJiraCheckSquareIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 2C0 0.895431 0.89543 0 2 0H12C13.1046 0 14 0.89543 14 2V12C14 13.1046 13.1046 14 12 14H2C0.895431 14 0 13.1046 0 12V2ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12V2C12.5 1.72386 12.2761 1.5 12 1.5H2ZM11.3262 4.48014L6.32617 10.4801C6.18367 10.6511 5.97258 10.75 5.75 10.75C5.52742 10.75 5.31633 10.6511 5.17383 10.4801L2.67383 7.48014L3.82617 6.51986L5.75 8.82846L10.1738 3.51986L11.3262 4.48014Z"
	})
});
export default SvgJiraCheckSquareIcon;
